import type { FC } from 'react';

import { Welcome } from './Steps/Welcome';
import { OnboardingContainer, MainRow, MainSection } from './styles';

export const GetStartedNew: FC = () => {
  return (
    <OnboardingContainer>
      <MainRow isSubpage={false} centerContent>
        <MainSection>
          <Welcome />
        </MainSection>
      </MainRow>
    </OnboardingContainer>
  );
};
